// extracted by mini-css-extract-plugin
module.exports = {"component":"sidebar-header-component--19grp"};